import { validators } from '@/shared/utils/validator';

export const useLoginValidate = () => {
  const validateEmail = (email: string) => {
    const emailValidation = validators.email(email);
    return emailValidation.valid ? '' : emailValidation.error;
  };

  const validatePassword = (password: string) => {
    const passwordValidation = validators.password(password);
    return passwordValidation.valid ? '' : passwordValidation.error;
  };

  return { validateEmail, validatePassword };
};
